import axios from "axios";
import url from "../config/urlServiceConfig";

const pillarAPI = {
  getAll: () => axios.get(url.pillar),
  getById: (id) => axios.get(`${url.pillar}/${id}`),
  create: (body) => axios.post(url.pillar, body),
  update: (body) => axios.put(url.pillar, body),
  delete: (id) => axios.delete(`${url.pillar}/${id}`),
};

export default pillarAPI;
